import Token from "../../login/vo/Token";
import { getStorageItem } from "../../common/scripts/localStorage/storage";

export function getStorageToken(storageKey): Token | null {
  const token = getStorageItem(storageKey);
  if (token !== null) {
    return JSON.parse(String(token));
  }
  return null;
}
